"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classcat = _interopRequireDefault(require("classcat"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LabelText = _interopRequireDefault(require("./LabelText"));

var _InputError = _interopRequireDefault(require("./InputError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TextArea = ({
  className,
  label,
  err,
  _ref,
  ...rest
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_LabelText.default, null, label), /*#__PURE__*/_react.default.createElement("textarea", _extends({
  className: (0, _classcat.default)({
    err
  }),
  type: "text",
  autoComplete: "off",
  ref: _ref
}, rest)), err && /*#__PURE__*/_react.default.createElement(_InputError.default, null, err)));

var _default = (0, _styledComponents.default)(TextArea).withConfig({
  displayName: "TextArea",
  componentId: "turdrn-0"
})(["margin-bottom:16px;textarea{margin-top:8px;padding:16px;width:100%;height:160px;min-height:160px;resize:vertical;font-weight:300;border-radius:2px;", ";&:focus:not(.err){border-color:", ";}&.err{border-color:", ";}}"], p => p.theme.transition, p => p.theme.colors.main, p => p.theme.colors.err);

exports.default = _default;